<ng-container *transloco="let t; read: 'settings'">
<h2 class="mbm">{{ t('activities') }}</h2>
<kendo-grid
  [data]="timeEntryCategories"
  (edit)="editHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  [style.maxHeight.px]="600"
>
  <ng-template kendoGridToolbarTemplate>
    <button kendoGridAddCommand>{{ t('add') }}</button>
  </ng-template>
  <kendo-grid-column field="name" [title]="t('name')">
    <ng-template kendoGridEditTemplate let-formGroup="formGroup">
      <kendo-formfield>
        <kendo-textbox [formControl]="formGroup.get('name')"></kendo-textbox>
        <kendo-formerror *ngIf="formGroup.get('name').hasError('required') || formGroup.get('name').hasError('pattern')">{{ t('isRequiredField') }}</kendo-formerror>
        <kendo-formerror *ngIf="formGroup.get('name').hasError('maxlength')">{{ t('nameTooLong', { max: 75 }) }}</kendo-formerror>
        <kendo-formerror *ngIf="formGroup.get('name').hasError('isNotUnique')">{{ t('nameMustBeUnique') }}</kendo-formerror>
      </kendo-formfield>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="isProductive" [title]="t('productive')" editor="boolean">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{ dataItem.isProductive ? t('yes') : t('no') }}
    </ng-template>
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
    >
      <input
        type="checkbox"
        kendoCheckBox
        [value]="dataItem.isProductive"
        [formControl]="formGroup.get('isProductive')"
      />
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="color" [title]="t('color')">
    <ng-template kendoGridCellTemplate let-dataItem>
      <kendo-colorpicker [value]="dataItem.color" disabled="true">
      </kendo-colorpicker>
    </ng-template>
    <ng-template
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-column="column"
      let-formGroup="formGroup"
    >
      <kendo-formfield>
        <kendo-colorpicker
          [value]="dataItem.color"
          [formControl]="formGroup.get('color')"
        >
        </kendo-colorpicker>
        <kendo-formerror *ngIf="formGroup.get('color').hasError('required')">{{ t('isRequiredField') }}</kendo-formerror>
      </kendo-formfield>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="sortOrder" [title]="t('order')">
    <ng-template kendoGridCellTemplate let-dataItem let-index let-isNew="isNew">
      <ng-container *ngIf="!isNew">
        {{ dataItem.sortOrder }}
        <button
          kendoButton
          [disabled]="timeEntryCategories.length - 1 <= dataItem.sortOrder"
          (click)="onMoveUp(dataItem, index)"
        >
          <kendo-svg-icon [icon]="icons.sortAsc"></kendo-svg-icon>
        </button>
        <button
          kendoButton
          [disabled]="dataItem.sortOrder <= 0"
          (click)="onMoveDown(dataItem, index)"
        >
          <kendo-svg-icon [icon]="icons.sortDesc"></kendo-svg-icon>
        </button>
      </ng-container>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column [title]="t('action')">
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button kendoGridEditCommand themeColor="primary">{{ t('edit') }}</button>
      <button kendoGridRemoveCommand>{{ t('remove') }}</button>
      <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
        {{ isNew ? t('add') : t('save') }}
      </button>
      <button kendoGridCancelCommand>
        {{ isNew ? t('discard') : t('cancel') }}
      </button>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>

<app-delete-confirm-dialog
  [(opened)]="deletionDialogOpened"
  [message]="t('deletionMessages.activity')"
  (confirmed)="deleteConfirmed()"
></app-delete-confirm-dialog>
</ng-container>
